import styled from 'styled-components';
export const GridContainer = styled.div `
    display: flex;
    overflow: auto;
    align-items: center;
    flex-direction: column;
    width: ${({ width }) => width ? width : 'auto'};
    height: ${({ height }) => height ? height : 'auto'};
`;
//# sourceMappingURL=Grid.styled.js.map